import {
  FETCH_CHAT_SESSIONS_SUCCESS,
  FETCH_CHAT_SESSIONS_FAIL,
  FETCH_INDIVIDUAL_CHAT_SESSION_SUCCESS,
  FETCH_INDIVIDUAL_CHAT_SESSION_FAIL,
  CONTINUE_CHAT_SESSION_ADD_SESSION_ID_TO_REDUX,
  MESSAGE_SENT_TO_CHAT_BOT_SUCCESS,
  MESSAGE_SENT_TO_CHAT_BOT_FAIL,
  NEW_CHAT_SESSION_STARTED_SUCCESS,
  NEW_CHAT_SESSION_STARTED_FAIL,
  SET_HAS_RESPONDED,
  RESET_CONTINUE_CHAT_SESSION,
  CHAT_SESSION_IS_NEW_RESET,
  SESSION_DELETE_SUCCESS,
  SESSION_DELETE_FAIL,
  CLEAR_INDIVIDUAL_CHAT_SESSION,
  HAS_CLICKED_ON_SEND_ACTIVE,
  HAS_CLICKED_ON_SEND_INACTIVE,
  ADDED_AI_MODEL,
  ADD_OPTIMISTIC_MESSAGE,
  CUSTOMER_CHATBOT_SUCCESS,
  CUSTOMER_CHATBOT_FAIL,
  FETCH_CUSTOMER_CHATBOT_SUCCESS,
  FETCH_CUSTOMER_CHATBOT_FAIL,
  CUSTOMER_CHATBOT_STREAM_START,
  CUSTOMER_CHATBOT_STREAM_CHUNK,
  CUSTOMER_CHATBOT_STREAM_DONE,
  CUSTOMER_CHATBOT_STREAM_ERROR,
  CHAT_STREAM_START,
  CHAT_STREAM_CHUNK,
  CHAT_STREAM_DONE,
  CHAT_STREAM_ERROR,
} from "../Actions/Types";

const initialState = {
  chatSessions: null,
  chatSessionsFetchSuccess: false,
  SideBarchatSessions: null,
  SideBarchatSessionsFetchSuccess: false,
  individualChatSession: null,
  individualChatSessionFetchSuccess: false,
  continueChatSessionId: null,
  isContinueChatSessionIdAddedToRedux: false,
  hasResponded: false,
  isNewChatSession: false,
  isClicked: false,
  individualChatSessionFailMessage: null,
  model: null,
  modelName: null,
  isChatStreaming: false,
  streamingChatMessage: "",
  customerChatbot: {
    messages: [],
    loading: false,
    error: null,
    isStreaming: false,
    streamingMessage: "",
  },
  customerChatbotFetchSuccess: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_CHAT_SESSIONS_SUCCESS:
      return {
        ...state,
        SideBarchatSessions: action.payload,
        SideBarchatSessionsFetchSuccess: true,
      };
    case FETCH_CHAT_SESSIONS_FAIL:
      return {
        ...state,
        chatSessions: null,
        chatSessionsFetchSuccess: false,
      };
    case FETCH_INDIVIDUAL_CHAT_SESSION_SUCCESS:
      return {
        ...state,
        individualChatSession: action.payload,
        individualChatSessionFetchSuccess: true,
      };
    case FETCH_INDIVIDUAL_CHAT_SESSION_FAIL:
      return {
        ...state,
        individualChatSession: null,
        individualChatSessionFetchSuccess: false,
        individualChatSessionFailMessage: action.payload.detail,
      };
    case CONTINUE_CHAT_SESSION_ADD_SESSION_ID_TO_REDUX:
      return {
        ...state,
        continueChatSessionId: action.payload,
        isContinueChatSessionIdAddedToRedux: true,
      };
    case RESET_CONTINUE_CHAT_SESSION:
      return {
        ...state,
        individualChatSession: [],
        continueChatSessionId: null,
        isContinueChatSessionIdAddedToRedux: false,
        isNewChatSession: true,
        individualChatSessionFailMessage: null,
      };
    case MESSAGE_SENT_TO_CHAT_BOT_SUCCESS:
      return {
        ...state,
        hasResponded: true,
        // Update the session title in the sidebar if it was generated
        SideBarchatSessions: action.payload.session_title
          ? state.SideBarchatSessions?.map((session) =>
              session.id === action.payload.session_id
                ? { ...session, title: action.payload.session_title }
                : session
            )
          : state.SideBarchatSessions,
      };
    case SET_HAS_RESPONDED:
      return {
        ...state,
        hasResponded: action.payload,
      };
    case NEW_CHAT_SESSION_STARTED_SUCCESS:
      return {
        ...state,
        isNewChatSession: true,
      };
    case NEW_CHAT_SESSION_STARTED_FAIL:
      return {
        ...state,
        isNewChatSession: false,
      };
    case CHAT_SESSION_IS_NEW_RESET:
      return {
        ...state,
        isNewChatSession: false,
      };
    case CLEAR_INDIVIDUAL_CHAT_SESSION:
      return {
        ...state,
        individualChatSession: null,
      };
    case HAS_CLICKED_ON_SEND_ACTIVE:
      return {
        ...state,
        isClicked: true,
      };
    case HAS_CLICKED_ON_SEND_INACTIVE:
      return {
        ...state,
        isClicked: false,
      };
    case ADDED_AI_MODEL:
      return {
        ...state,
        model: action.payload.model,
        modelName: action.payload.modelName,
      };
    case ADD_OPTIMISTIC_MESSAGE:
      return {
        ...state,
        individualChatSession: Array.isArray(state.individualChatSession)
          ? [...state.individualChatSession, action.payload]
          : [action.payload],
      };
    case CUSTOMER_CHATBOT_SUCCESS:
    case FETCH_CUSTOMER_CHATBOT_SUCCESS:
      return {
        ...state,
        customerChatbot: {
          ...state.customerChatbot,
          messages: action.payload.messages || [],
          loading: false,
          error: null,
        },
        customerChatbotFetchSuccess: true,
      };
    case CUSTOMER_CHATBOT_FAIL:
    case FETCH_CUSTOMER_CHATBOT_FAIL:
      return {
        ...state,
        customerChatbot: {
          ...state.customerChatbot,
          loading: false,
          error: action.payload,
        },
        customerChatbotFetchSuccess: false,
      };
    case CHAT_STREAM_START:
      return { ...state, isChatStreaming: true, streamingChatMessage: "" };
    case CHAT_STREAM_CHUNK:
      return {
        ...state,
        streamingChatMessage: state.streamingChatMessage + action.payload,
      };
    case CHAT_STREAM_DONE:
      return {
        ...state,
        isChatStreaming: false,
        streamingChatMessage: "",
        individualChatSession: [
          ...(Array.isArray(state.individualChatSession) ? state.individualChatSession : []),
          {
            id: `bot_${Date.now()}`,
            role: "bot",
            content: state.streamingChatMessage,
            timestamp: new Date().toISOString(),
            wasStreamed: true,
          },
        ],
        SideBarchatSessions: action.payload?.sessionTitle
          ? state.SideBarchatSessions?.map((s) =>
              s.id === action.payload.sessionId
                ? { ...s, title: action.payload.sessionTitle }
                : s
            )
          : state.SideBarchatSessions,
      };
    case CHAT_STREAM_ERROR:
      return {
        ...state,
        isChatStreaming: false,
        streamingChatMessage: "",
        individualChatSession: Array.isArray(state.individualChatSession)
          ? [
              ...state.individualChatSession,
              {
                id: `error_${Date.now()}`,
                role: "bot",
                content: action.payload || "Something went wrong. Please try again.",
                timestamp: new Date().toISOString(),
                isError: true,
              },
            ]
          : state.individualChatSession,
      };
    case CUSTOMER_CHATBOT_STREAM_START:
      return {
        ...state,
        customerChatbot: {
          ...state.customerChatbot,
          messages: [
            ...state.customerChatbot.messages,
            {
              id: `user_${Date.now()}`,
              role: "user",
              content: action.payload.content,
              timestamp: new Date().toISOString(),
            },
          ],
          isStreaming: true,
          streamingMessage: "",
        },
      };
    case CUSTOMER_CHATBOT_STREAM_CHUNK:
      return {
        ...state,
        customerChatbot: {
          ...state.customerChatbot,
          streamingMessage: state.customerChatbot.streamingMessage + action.payload,
        },
      };
    case CUSTOMER_CHATBOT_STREAM_DONE:
      return {
        ...state,
        customerChatbot: {
          ...state.customerChatbot,
          messages: [
            ...state.customerChatbot.messages,
            {
              id: `bot_${Date.now()}`,
              role: "bot",
              content: state.customerChatbot.streamingMessage,
              timestamp: new Date().toISOString(),
            },
          ],
          isStreaming: false,
          streamingMessage: "",
        },
      };
    case CUSTOMER_CHATBOT_STREAM_ERROR:
      return {
        ...state,
        customerChatbot: {
          ...state.customerChatbot,
          messages: [
            ...state.customerChatbot.messages,
            {
              id: `error_${Date.now()}`,
              role: "bot",
              content: action.payload || "Something went wrong. Please try again.",
              timestamp: new Date().toISOString(),
              isError: true,
            },
          ],
          isStreaming: false,
          streamingMessage: "",
        },
      };
    default:
      return state;
  }
}
